import menu from './menu.js';
import locator from './locator.js';
import contact from './contact.js';
import newsletter from './newsletter.js';
import magazines from './magazines.js';
import freesmokedetector from './freesmokedetector.js';

$(document).ready(function(){
	//Cookies
	if(localStorage.getItem('cookiesAccepted') == null){
		$("#cookie-container").removeClass("hide");
	}else{
		$("#cookie-container").addClass("hide");
	}
	
	$("#accept-cookies-button").unbind("click");
	$("#accept-cookies-button").bind("click",function(){
		$.ajax({
		  type: "POST",
		  url: "/cookie/accept",
		  data: {accept:true},
		  success: function(data){
			  if(data.message.toLowerCase() == 'true'){
				localStorage.setItem('cookiesAccepted', "true");
				$("#cookie-container").hide("400");  
			  }else{
				$("#cookie-container").show("400");   
			  }
		  }
		});
	});
		
	//Scroll down on arrow down click
	$(".content-header-scroll-down, .carousel-scroll-down").unbind("click");
	$(".content-header-scroll-down, .carousel-scroll-down").bind("click",function(e) {
		var headerContainer = $(this).parent();
		
		if(headerContainer.attr("class") == "carousel-scroll-down-container"){
			headerContainer = $(this).parent().parent();
		}
		
		if(headerContainer.length > 0){
			var smallMenuHeight = 50;
		
			$('html, body').animate({
				scrollTop: smallMenuHeight + headerContainer.height()
			 }, 800);
		}
		
		e.preventDefault();
	});
	
    //Carousel Bootstrap
    $('.carousel').carousel({
	  interval: 7000
	});	
	
	//Add touch events for hover state
	$('.main-cta').on('touchstart touchend', function(e) {
		$(this).toggleClass('hover');         
	});
	
	$('.service').on('touchstart touchend', function(e) {
		$(this).toggleClass('hover');         
	});
	
	//AOS animations
	AOS.init({
      duration : 2000
    })
	
	//Go back buttons
	if(window.history.length > 1){
		$(".btn-go-back").removeClass("hide");
	}
	
	$(".btn-go-back").unbind("click");
	$(".btn-go-back").bind("click",function(e) {
		window.history.back();
	});
	
	//Set travel location link
	if($(".travel-directions-link").length > 0){
		var currentLink = $(".travel-directions-link:first").attr("href");
		var newLink = "";
		
		if(localStorage.getItem('userLocation') != null){
			newLink = currentLink.replace("saddr=","saddr=" + localStorage.getItem('userLocation'));		
		}else{
			newLink = currentLink.replace("saddr=","saddr=Brussels, Belgium");		
		}
		$(".travel-directions-link").attr("href", newLink);
	}
	
	//Menu
	menu.init();
	
	//Magazines
	magazines.init();

	//Newsletter
	newsletter.init();
	
	//Contact form
	contact.init();
	
	//Map
	locator.init();
	
	//Free smoke detector
	freesmokedetector.init();
});

// Multilevel navigation
/* Open */
var scrollTop = 0;
function navToggler() {
    var nav = $("#main-nav");
	var navToggle = $(".nav-toggle:first");
	var header = $(".header");

    if (nav.height() == 0) {
		scrollTop = $(window).scrollTop();
		
		nav.addClass("menu-expanded");	
		navToggle.addClass("menu-active");
		
		$("body").css("position","fixed");
		$("body").css("width","100%");
    } else {
		nav.removeClass("menu-expanded");
		navToggle.removeClass("menu-active");
		
		$("body").css("position","static");
		$("body").css("width","auto");
		$(window).scrollTop(scrollTop);
    }
};

function setMenu(){
	if($(document).scrollTop() > 100) {
		$(".header").removeClass("scrolled-top").addClass("scrolled-down");
	} else {
		$(".header").removeClass("scrolled-down").addClass("scrolled-top");
	}
}

